import React from 'react'
import classNames from 'classnames'

import styles from './styles.module.scss'

import type { LabelValueRowProps } from './types'

export const LabelValueRow: React.FC<LabelValueRowProps> = ({ label, value, hasSeparator, fallbackValue }) => {
  const className: string = classNames(styles.row, { [styles.row_separated]: hasSeparator })

  return (
    <div className={ className }>
      <span className={ styles.row__title }>{ label }</span>
      <span className={ styles.row__value }>{ value ?? fallbackValue }</span>
    </div>
  )
}
